import React from 'react'
import FlightOffersWorker from './flight-offers'
import { Link, withRouter } from 'react-router-dom'
import iconEdit from '../../../assets/icons/edit-black.svg'
import iconDelete from '../../../assets/icons/delete-black.svg'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import NumberFormat from 'react-number-format'

class FlightOffers extends React.Component {

    constructor() {
        super()
        this.flightOffersWorker = FlightOffersWorker(this)
        this.state = this.flightOffersWorker.getDefaultState()
    }

    componentDidMount() {
        this.flightOffersWorker.loadFlightOffers()
    }

    onDelete = id => this.flightOffersWorker.deleteFlightOffer(id)

    getStatusLabel = status => {
        switch (Number(status)) {
            case 0:
                return "Draft"
            case 1:
                return "Published"
            case 2:
                return "Archived"
            default:
                return status
        }
    }

    getTripTypeLabel = tripType => {
        switch (Number(tripType)) {
            case 0:
                return "One Way"
            case 1:
                return "Return"
            default:
                return tripType
        }
    }

    getBadgeLabel = badge => {
        switch (Number(badge)) {
            case 0:
                return "None"
            case 1:
                return "Available"
            case 2:
                return "Promotion"
            case 3:
                return "Fast Selling"
            default:
                return badge
        }
    }

    render() {
        return (
            <div className="flight-offers">
                {
                    this.state.loading && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/flight-offers/create">New Flight Offer</Link>
                    <div className="header">
                        <h4>Flight Offers</h4>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Airline</th>
                                <th>Route</th>
                                <th>Trip Type</th>
                                <th>Badge</th>
                                <th>Price</th>
                                <th>Currency</th>
                                <th>Status</th>
                                <th>Updated</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.flightOffers.map((flightOffer, key) => {
                                    const updatedAt = flightOffer.updatedAt || flightOffer.updated
                                    return (
                                        <tr key={key}>
                                            <td>{flightOffer.airlineName}</td>
                                            <td>{flightOffer.departureCode} ({flightOffer.departureCity}) - {flightOffer.arrivalCode} ({flightOffer.arrivalCity})</td>
                                            <td>{this.getTripTypeLabel(flightOffer.tripType)}</td>
                                            <td>{this.getBadgeLabel(flightOffer.badge)}</td>
                                            <td><NumberFormat value={flightOffer.price} displayType="text" thousandSeparator={true} /></td>
                                            <td>{flightOffer.currency}</td>
                                            <td>{this.getStatusLabel(flightOffer.status)}</td>
                                            <td>{updatedAt ? new Date(updatedAt).toLocaleString() : "-"}</td>
                                            <td>
                                                <div className="actions">
                                                    <img alt="" src={iconEdit} onClick={() => this.props.history.push('/content/flight-offers/edit/' + flightOffer.id)} />
                                                    {
                                                        this.state.deletingId === flightOffer.id ? <Loading /> : <img alt="" src={iconDelete} onClick={() => this.onDelete(flightOffer.id)} />
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default withRouter(FlightOffers)
